import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import Link from "@material-ui/core/Link";
import MenuItem from "@material-ui/core/MenuItem";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import ContactDrawerSkeleton from "../ContactDrawerSkeleton";
import { getAllItems, deleteItem } from "../../helpers/IndexedDb";

const drawerWidth = 320;

const useStyles = makeStyles((theme) => ({
	drawer: {
		width: 0,
		flexShrink: 0,
		transitionDuration: "0.3s",
	},
	drawerPaper: {
		width: drawerWidth,
		display: "flex",
		borderTop: "1px solid rgba(0, 0, 0, 0.12)",
		borderRight: "1px solid rgba(0, 0, 0, 0.12)",
		borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
		borderTopRightRadius: 4,
		borderBottomRightRadius: 4,
	},
	header: {
		display: "flex",
		borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
		backgroundColor: "#eee",
		alignItems: "center",
		padding: theme.spacing(0, 1),
		minHeight: "73px",
		justifyContent: "flex-start",
	},
	content: {
		display: "flex",
		backgroundColor: "#eee",
		flexDirection: "column",
		padding: "8px 0px 8px 8px",
		height: "100%",
		overflowY: "scroll",
		...theme.scrollbarStyles,
	},
	contactAvatar: {
		margin: 15,
		width: 100,
		height: 100,
		cursor: "pointer",
		transition: "transform 0.2s ease",
		"&:hover": {
			transform: "scale(1.05)",
		},
	},
	contactHeader: {
		display: "flex",
		padding: 8,
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		"& > *": {
			margin: 4,
		},
	},
	contactDetails: {
		marginTop: 8,
		padding: 8,
		display: "flex",
		flexDirection: "column",
	},
	motivoBotao: {
		width: "100%",
	},
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	modalImage: {
		maxWidth: "90%",
		maxHeight: "90%",
		borderRadius: 8,
		boxShadow: theme.shadows[5],
	},
}));

const BootstrapInput = withStyles((theme) => ({
	root: { "label + &": {} },
	input: {
		width: "195px",
		borderRadius: 4,
		position: "relative",
		backgroundColor: theme.palette.background.paper,
		border: "1px solid #ced4da",
		fontSize: 16,
		padding: "10px 26px 10px 12px",
		transition: theme.transitions.create(["border-color", "box-shadow"]),
		fontFamily: [
			"-apple-system",
			"BlinkMacSystemFont",
			'"Segoe UI"',
			"Roboto",
			'"Helvetica Neue"',
			"Arial",
			"sans-serif",
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(","),
		"&:focus": {
			borderRadius: 4,
			borderColor: "#80bdff",
			boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
		},
	},
}))(InputBase);

const ContactDrawer = ({
	open,
	handleDrawerClose,
	contact,
	ticket,
	byTicketManagement = false,
	canSendMessageForGroup,
}) => {
	const classes = useStyles();
	const history = useHistory();
	const [selectedConclusionMessage, setSelectedConclusionMessage] = useState({ id: null, message: "" });
	const [conclusionMessage, setConclusionMessage] = useState(null);
	const [loading, setLoading] = useState(false);
	const [openImage, setOpenImage] = useState(false);
	const { user } = useContext(AuthContext);
  	const hasProfilePic = Boolean(contact?.profilePicUrl);

	const handleAvatarClick = (e) => {
		e.stopPropagation();
		if (!hasProfilePic) return;
		setOpenImage(true);
	};
	const handleCloseImage = () => setOpenImage(false);

	const handleUpdateTicketStatus = async (e, status) => {
		if (!selectedConclusionMessage?.id) {
			toastError({ response: { data: { error: "ERR_CONCLUDE_FOUND" } } });
			return;
		}

		const input = document.getElementById("motivo_input");
		const reason = input.value;
		setLoading(true);

		try {

			setTimeout(async () => {
				await api.put(`/tickets/${ticket.id}`, {
					status: "closed",
					reason,
					conclusionId: selectedConclusionMessage.id ? selectedConclusionMessage.id : null,
					
				});

				if (byTicketManagement) {
					history.push(status === "open" ? `/ticketManagement/${ticket.id}` : "/ticketManagement");
				} else {
					history.push(status === "open" ? `/tickets/${ticket.id}` : "/tickets");
				}

				setLoading(false);
				toast.success(i18n.t("Atendimento finalizado!"));

				// limpa mensagens locais
				if (user?.adminId && ticket?.id) {
					const indexedDbKey = `listMessages-ticketId${ticket.id}-user${user.id}-pageNumber`;
					const localValues = await getAllItems(user?.adminId);
					const pages = [];
					if (Array.isArray(localValues))
						localValues.map((lv) => {
							if (lv.key.includes(indexedDbKey)) pages.push(lv);
						});
					for (let x = pages.length - 1; x >= 0; x--) {
						await deleteItem(user.adminId, pages[x].id);
					}
				}
			}, 500);
		} catch (err) {
			console.error({ err });
			setLoading(false);
			toastError(err);
		}
	};

	async function sendFlashMessage(data) {
		if (user?.signature && user?.name) data = `*${user.name.trim()}:*\n` + data.trim();
		const message = {
			read: 1,
			fromMe: true,
			body: data,
			cleanMsg: data.trim(),
			awaitSendMessage: true,
			moduleId: ticket.whatsapp.moduleId,
		};
		await api.post(`/messages/${ticket.id}`, message);
	}

	useEffect(() => {
		let isMounted = true;
		const abortController = new AbortController();

		const delay = setTimeout(() => {
			api.get("/conclusionMessagesAll/", { signal: abortController.signal })
				.then(({ data }) => {
					if (!isMounted) return;
					setConclusionMessage(data.conclusionMessages);
				})
				.catch((err) => {
					if (!isMounted || err.name === "AbortError") return;
					console.error(err);
					toastError(err);
				});
		}, 500);

		return () => {
			isMounted = false;
			abortController.abort();
			clearTimeout(delay);
		};
	}, [open]);

	const handleConclusionMessage = (id) => {
		const found = conclusionMessage.find((cm) => cm.id === id);
		setSelectedConclusionMessage({ id: found.id, message: found.message });
	};

	return (
		<>
			<Drawer
				className={classes.drawer}
				id="ModalConcluir"
				variant="persistent"
				anchor="right"
				open={open === true}
				PaperProps={{ style: { position: "absolute" } }}
				classes={{ paper: classes.drawerPaper }}
			>
				<div className={classes.header}>
					<IconButton
						onClick={(e) => {
							handleDrawerClose(e);
							setSelectedConclusionMessage({ id: null, message: "" });
							document.querySelector('[id="motivo_input"]').value = "";
						}}
					>
						<CloseIcon />
					</IconButton>
					<Typography>{i18n.t("contactDrawer.headerConclude")}</Typography>
				</div>

				{loading ? (
					<ContactDrawerSkeleton classes={classes} />
				) : (
					<div className={classes.content}>
						<Paper square variant="outlined" className={classes.contactHeader}>
							<Avatar
								alt={contact.name}
            					src={hasProfilePic ? contact.profilePicUrl : undefined}
								className={classes.contactAvatar}
								onClick={handleAvatarClick}
            					style={{ cursor: hasProfilePic ? "zoom-in" : "default" }}
							/>
							<Typography>{contact.name}</Typography>
							<Typography>
								<Link href={`https://api.whatsapp.com/send?phone=${contact.number}`}>
									{contact.number}
								</Link>
							</Typography>
						</Paper>

						<Paper square variant="outlined" className={classes.contactDetails} style={{ marginTop: 10 }}>
							<DialogTitle>Finalização</DialogTitle>
							<DialogContent dividers>
								<label>
									Selecione uma finalização
									<Typography component="span" style={{ marginLeft: 5 }} color="secondary">
										*
									</Typography>
								</label>
								<Select
									value={selectedConclusionMessage?.id}
									onChange={(e) => handleConclusionMessage(e.target.value)}
									input={<BootstrapInput />}
									required
								>
									<MenuItem disabled value="">
										Selecione uma mensagem
									</MenuItem>
									{Array.isArray(conclusionMessage) &&
										conclusionMessage.map((msg, index) => (
											<MenuItem key={index} title={msg.message} value={msg.id}>
												{msg.shortcut}
											</MenuItem>
										))}
								</Select>
							</DialogContent>

							<DialogContent dividers>
								<label>Descreva o motivo da finalização:</label>
								<input
									id="motivo_input"
									style={{
										borderColor: "#c4c4c4",
										borderRadius: "3px",
										width: "100%",
										height: "45px",
									}}
									type="text"
									className="form-control"
									name="finishReason"
								/>
							</DialogContent>

							<DialogContent dividers>
								<Button
									className={classes.motivoBotao}
									variant="contained"
									color="primary"
									onClick={(e) => handleUpdateTicketStatus(e, "closed")}
								>
									{i18n.t("messagesList.header.buttons.conclude")}
								</Button>
							</DialogContent>
						</Paper>
					</div>
				)}
			</Drawer>

			{/* Modal da imagem ampliada */}
			<Modal open={openImage} onClose={handleCloseImage} className={classes.modal}>
				<img
					src={contact.profilePicUrl}
					alt="contact_image_large"
					className={classes.modalImage}
					onClick={handleCloseImage}
				/>
			</Modal>
		</>
	);
};

export default ContactDrawer;
